export var CHAIN_TYPES;
(function(CHAIN_TYPES) {
    CHAIN_TYPES["EVM"] = "EVM";
    CHAIN_TYPES["Solana"] = "Solana";
    CHAIN_TYPES["Near"] = "Near";
})(CHAIN_TYPES || (CHAIN_TYPES = {}));
export var SOLANA_CHAINS;
(function(SOLANA_CHAINS) {
    SOLANA_CHAINS["DevNet"] = "devnet";
    SOLANA_CHAINS["TestNet"] = "testnet";
    SOLANA_CHAINS["MainNet"] = "mainnet";
})(SOLANA_CHAINS || (SOLANA_CHAINS = {}));
export var NEAR_CHAINS;
(function(NEAR_CHAINS) {
    NEAR_CHAINS["TestNet"] = "testnet";
    NEAR_CHAINS["MainNet"] = "mainnet";
})(NEAR_CHAINS || (NEAR_CHAINS = {}));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnVtcy9jaGFpbnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gQ0hBSU5fVFlQRVMge1xuICBFVk0gPSAnRVZNJyxcbiAgU29sYW5hID0gJ1NvbGFuYScsXG4gIE5lYXIgPSAnTmVhcicsXG59XG5leHBvcnQgZW51bSBTT0xBTkFfQ0hBSU5TIHtcbiAgRGV2TmV0ID0gJ2Rldm5ldCcsXG4gIFRlc3ROZXQgPSAndGVzdG5ldCcsXG4gIE1haW5OZXQgPSAnbWFpbm5ldCcsXG59XG5cbmV4cG9ydCBlbnVtIE5FQVJfQ0hBSU5TIHtcbiAgVGVzdE5ldCA9ICd0ZXN0bmV0JyxcbiAgTWFpbk5ldCA9ICdtYWlubmV0Jyxcbn1cbiJdLCJuYW1lcyI6WyJDSEFJTl9UWVBFUyIsIlNPTEFOQV9DSEFJTlMiLCJORUFSX0NIQUlOUyJdLCJyYW5nZU1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OyIsIm1hcHBpbmdzIjoiO1VBQVlBOzs7O0dBQUFBLGdCQUFBQTs7VUFLQUM7Ozs7R0FBQUEsa0JBQUFBOztVQU1BQzs7O0dBQUFBLGdCQUFBQSJ9